
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { dataService } from "../../services/data.services";


const initialState = {
    loading: true,
    error: '',
    success: '',
    dateObject:{start_date:null,end_date:null}
}
export const Branch = createAsyncThunk('branch-list', async (searchParams) => {
    let res = await dataService.GetAPI(`branch?${(searchParams.toString())}`);
    return res
})
const BranchSlice = createSlice({

    name: 'branch-list',
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = true
        },
        DateFilter: (state, action) => {
            state.dateObject = action.payload
        }

    },
    extraReducers: {
        [Branch.pending]: (state) => {
            state.loading = true
            state.error = null
        },
        [Branch.fulfilled]: (state, action) => {
            state.loading = false;
            if(!action?.payload?.error && action?.payload?.data.status===200){
                state.List=action?.payload?.data.data;
                
            }else{
                state.error=action?.payload?.data?.message
            }
        },
        [Branch.rejected]: (state, { payload }) => {
            state.loading = false
            state.error = payload?.message?.message
        },
    },
})
export const { setLoading ,DateFilter} = BranchSlice.actions;
export default BranchSlice.reducer